import {
  Container,
  ContainerInner,
  Heading,
  Paragraph,
  HeadingContainer,
} from '../Landing/landing.styles';

const ThankYouPage = () => (
  <Container>
    <ContainerInner>
      <HeadingContainer>
        <Heading>Thank you for completing the survey!</Heading>
      </HeadingContainer>
      <Paragraph>
        We appreciate the time you have taken and the effort you put toward
        transport decarbonization.
      </Paragraph>
      <Paragraph>
        Your answers are now being analyzed. Please check your email (including
        spam folder) in a few minutes to download the report.
      </Paragraph>
    </ContainerInner>
  </Container>
);

export default ThankYouPage;
